document.addEventListener('DOMContentLoaded', function () {
  const emailForm = document.querySelector('.home-template .gh-footer-signup form.gh-form, .page-meetings .gh-footer-signup form.gh-form');
  if (emailForm) {
    emailForm.classList.add('dh-email-capsule');
  }
});
